module.exports = __webpack_public_path__ + "img/applist-mobile.8b1c8249.jpg";